import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';

class Popup extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}
	handleClosePopup = () => {
		const closePopupToggle = this.selector.querySelector( '.close-popup-toggle' ) as HTMLElement;
		if ( closePopupToggle ) {
			closePopupToggle.addEventListener( 'click', () => {
				this.selector.remove();
				document.body.classList.remove('overflow-hidden')
			} );
		}
	};
	init() {
		this.handleClosePopup();
	}
}

export default Popup;
